<template>
  <div class="back" ref="homePage">
    <div class="videoDiv">
      <video controls class="video_d" autoplay>
        <source src="/static/保康县举行防灾减灾综合应急演练.mp4" type="video/mp4"/>
      </video>
    </div>
    <!-- 首页btn -->
    <div class="indexBtn" @click="toIndex">
      <el-button type="warning" icon="el-icon-s-home" circle>
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  created() {
  },
  data() {
    return {
      clientHeight: ""
    };
  },
  mounted() {
    // 获取浏览器可视区域高度
    this.clientHeight = `${document.documentElement.clientHeight}`; //document.body.clientWidth;
    //console.log(self.clientHeight);
    window.onresize = function temp() {
      this.clientHeight = `${document.documentElement.clientHeight}`;
    };
  },
  watch: {
    // 如果 `clientHeight` 发生改变，这个函数就会运行
    clientHeight: function () {
      this.changeFixed(this.clientHeight);
    }
  },
  methods: {
    toPhoneVideo() {
      this.$router.push({path: "/phone_viode"});
    },
    toIndex() {
      this.$router.push({path: "/"});
    },
    changeFixed(clientHeight) {
      //动态修改样式
      console.log(clientHeight);
      this.$refs.homePage.style.height = clientHeight + "px";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  margin: 0;
  padding: 0;
}

.back {
  width: 100%;
  background-image: url("../../assets/images/video_pageHome.jpg");
  background-size: 100% 100%;
}

.imageDiv {
  width: 80%;
  margin: 0 auto;
  padding-top: 23%;
}

.imageDiv2 {
  width: 80%;
  margin: 0 auto;
  padding-top: 6%;
}

.index_btn_video {
  width: 100%;
  height: 100%;
}

.videoDiv {
  width: 90%;
  height: 300px;
  margin: 0 auto;
  padding-top: 30%
}

.video_d {
  width: 100%;
  height: 100%;
}

.indexBtn {
  position: fixed;
  top: 5%;
  right: 3%;
}
</style>



// WEBPACK FOOTER //
// src/components/phone/phone_video.vue